import { createBrowserHistory } from 'history';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { BrowserRouter, Router } from 'react-router-dom';
import ScrollMemory from 'react-router-scroll-memory';

import { AppContextProvider } from '@/contexts/AppContext';
import { InternationalizationProvider } from '@/contexts/InternationalizationContext';
import { ResponsiveProvider } from '@/contexts/ResponsiveContext';

const history = createBrowserHistory();

const MainProvider = ({ children }) => {
  
  return (
    <Router history={history}>
      <BrowserRouter>
        <ScrollMemory/>
        <ResponsiveProvider>
          <InternationalizationProvider>
            <AppContextProvider>
              {children}
            </AppContextProvider>
          </InternationalizationProvider>
        </ResponsiveProvider>
      </BrowserRouter>
    </Router>
  );
};

MainProvider.propTypes = {
  children: PropTypes.any,
  isMobile: PropTypes.bool
};

export default memo(MainProvider);
